import { useState, useEffect } from "react";
import axios from "axios";
import SidebarUser from "./Sidebar";
import HeaderUser from "./Header";
import { FaRobot } from "react-icons/fa6";
import { CONST } from '../../../_config';
import { authHeader } from '../../../_helpers';

export default function Dashboard({
  children, logo
}) {

  const [collapsed, setCollapsed] = useState(
    window.innerWidth < 768
  );

  // ✅ NEW STATE FOR API DATA
  const [insightData, setInsightData] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const resize = () => {
      if (window.innerWidth < 768) setCollapsed(true);
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);


  const onLogout = async () => {
    try {
      await axios.post(
        `${CONST.BACKEND_EMPROLE_URL}/logoutSession`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: authHeader().Authorization,
          },
        }
      );

      // ✅ साफ़ करो session
      localStorage.clear();
      sessionStorage.clear();
      // ✅ redirect
      window.location.href = "#/insight/signin";

    } catch (err) {
      console.error("Logout failed:", err);
      // even if API fails → force logout
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "#/insight/signin";
    }
  };

  useEffect(() => {
    const fetchInsightUser = async () => {
      try {
        const value = {}; // 👉 put your payload here if needed
        const res = await axios.post(
          `${CONST.BACKEND_EMPROLE_URL}/getInsightUser`,
          value, // ✅ body
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: authHeader().Authorization, // ✅ auth
            },
          }
        );
        setInsightData(res.data);
      } catch (err) {
        console.error("Error fetching insight user:", err);
      }
    };
    fetchInsightUser();
  }, []);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden relative">

      {!isOnline && (
        <div className="fixed bottom-0 inset-x-0 bg-red-600 font-semibold text-white text-lg text-center p-2 z-[100]">
          You are currently offline. Please check your internet connection and refresh the page once you're back online.
        </div>
      )}

      {/* SIDEBAR */}
      <SidebarUser
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        logo={logo}
      />

      {/* MAIN AREA */}
      <div className={`flex flex-col flex-1 transition-all duration-300 ml-0 ${collapsed ? "md:ml-20" : "md:ml-64"}`}>
        <HeaderUser
          collapsed={collapsed}
          toggleSidebar={toggleSidebar}
          onLogout={onLogout}
          userDetails={insightData?.data || {}}
        />

        <main className="flex-1 overflow-y-auto mt-20 bg-white">
          {children}
        </main>
      </div>


    </div>
  );
}